import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Item } from 'semantic-ui-react';
import _ from 'lodash';

import IconButton from '../IconButtons';
import './EntryItem.css';

class EntryItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverState: this.isTouchDevice() || props.isMobile ? true : false,
      isSelected: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const selection = this.props.isSelected !== nextProps.isSelected
        || this.state.isSelected !== nextState.isSelected;
    const title = this.props.entry.title !== nextProps.entry.title;
    const isRead = this.props.entry.isRead !== nextProps.entry.isRead;
    const hover = this.state.hoverState !== nextState.hoverState;
    const tags = !_.isEqual(this.props.tags, nextProps.tags);
    return title || hover || selection || tags || isRead;
  }

  isTouchDevice() {
   return (('ontouchstart' in window)
      || (navigator.MaxTouchPoints > 0)
      || (navigator.msMaxTouchPoints > 0));
  }

  onMouseEnter = () => {
    this.setState({ hoverState: true });
  };

  onMouseLeave = () => {
    if (!this.isTouchDevice() && !this.props.isMobile)
        this.setState({ hoverState: false });
  };

  handleSelect = () => {
    const { isSelected, handleSelected, handleUnselected, entry } = this.props;
    if (!handleSelected || !handleUnselected) {
      this.setState({ isSelected: !this.state.isSelected })
      return;
    }
    if (isSelected) {
      handleUnselected(entry.id);
    } else {
      handleSelected(entry.id);
    }
  };

  handleButtonClick = (e, handleClick) => {
    const { entry, tags } = this.props;
    handleClick && handleClick(entry, tags);
    e.preventDefault();
    e.stopPropagation();
  }

  handleClick = () => {
    window.open(this.props.entry.url, '_blank');
    this.props.handleOpened(this.props.entry.id);
  }

  renderRead = (toggleIsRead, isRead) => {
    return (
      <IconButton
        name={isRead ? 'checked' : 'check'}
        onClick={e => {this.handleButtonClick(e, toggleIsRead )}} />
    )
  }

  render() {
    const isSelected = this.props.isSelected || this.state.isSelected;
    const { id, title, faviconUrl, tags } = this.props.entry;
    const filteredTags = this.props.hiddenTags ?
        _.difference(tags, this.props.hiddenTags) : tags;

    const renderEditButtons = () => {
      const { handleDelete, toggleIsRead, entry } = this.props;
      if (this.state.hoverState && handleDelete && toggleIsRead) {
        return (
          <Item.Content className='icon-buttons-container' verticalAlign="middle">
            <IconButton
              name={'trash'}
              onClick={e => {this.handleButtonClick(e, handleDelete)}} />
            { this.renderRead(toggleIsRead, entry.isRead) }
          </Item.Content>
        );
      } else if (entry.isRead) {
        return (
          <Item.Content className='icon-buttons-container' verticalAlign="middle">
            { this.renderRead(toggleIsRead, true) }
          </Item.Content>
        )
      }
    };

    const renderLabel = (id, isSelected) => {
      if (!isSelected && !this.state.hoverState) {
        return <Item.Image size="mini" src={faviconUrl} />;
      } else {
        return (
          <IconButton
            active={isSelected}
            name={'select'}
            onClick={e => {this.handleButtonClick(e, this.handleSelect)}}
          />
        );
      }
    };

    const showTags = filteredTags && filteredTags.length > 0;
    const contentClasses = showTags ? 'entry-content' : 'entry-content no-tags'
    const itemClasses = isSelected ? 'entry-feed-item link selected': 'entry-feed-item link';
    return (
      <Item
        className={itemClasses}
        key={id}
        onClick={this.handleClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>

        {renderLabel(id, isSelected)}
        <Item.Content verticalAlign="middle" className={contentClasses}>
          <Item.Header className={'ui'}>{title}</Item.Header>
          { showTags &&
              <Item.Extra>
                {filteredTags.map((tag, i) => {
                  return (
                    <div className="tag" key={tag}>
                      {`#${tag}`}
                    </div>
                  );
                })}
              </Item.Extra>
            }
        </Item.Content>
        {renderEditButtons()}
      </Item>
    );
  }
}

EntryItem.propTypes = {
  entry: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    isRead: PropTypes.bool.isRequired,
    faviconUrl: PropTypes.string,
    dateAdded: PropTypes.shape({
      milliseconds: PropTypes.number,
      seconds: PropTypes.number
    }).isRequired,
    tags: PropTypes.array
  }).isRequired,
  hiddenTags: PropTypes.array,
  handleSelected: PropTypes.func,
  handleUnselected: PropTypes.func,
  handleDelete: PropTypes.func,
  handleOpened: PropTypes.func.isRequired,
  toggleIsRead: PropTypes.func,
  isSelected: PropTypes.bool
};

export default EntryItem;



// WEBPACK FOOTER //
// ./src/components/EntryItem/index.js